import { DropdownItemProps } from '@cas/components/inputs/dropdown-items/DropdownItems';
import { MapProviderType } from '@cas/types/settings';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useMapProviderOptions = (): DropdownItemProps<MapProviderType>[] => {
  const { t } = useTranslation();

  const items = useMemo(() => {
    return Object.values(MapProviderType).map((value: MapProviderType) => {
      return {
        key: value,
        value,
        stringValue: value,
        label: t(`MapProviderType.${value}`),
      };
    });
  }, [t]);

  return items;
};

export default useMapProviderOptions;
